import type { FieldSchemaFactory, ValidationRule } from './types';

export type SchemaEntry = readonly [ValidationRule, FieldSchemaFactory];

export const createFieldSchemaRegistry = (
  schemaEntries: ReadonlyArray<SchemaEntry>,
): Map<ValidationRule, FieldSchemaFactory> => {
  if (schemaEntries.length === 0) {
    throw new Error('No schemas found');
  }

  if (new Set(schemaEntries.map(([key]) => key)).size !== schemaEntries.length) {
    throw new Error('Duplicate schema entries found');
  }

  if (schemaEntries.some(([key, factory]) => typeof factory !== 'function')) {
    throw new Error('Invalid schema factory found');
  }

  return new Map(schemaEntries);
};
